import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoginRequest, LoginResponse, LoginDataResponse, CondominiumConfigurationResponse, Condominium, CondominiumResponse, InvitationFields, Modules_app, InviteOptions, Notifications, LoginValidationResponse, ViewNotificationResponse, ViewNotification, ViewNotificationRequest, FinanceResponse, Finance, ExpensesResponse, Expenses, DetailExpenseResponse, DetailExpense, ResetValidateResponse, ChangePasswordValidateResponse, ResetPasswordRequest, ChangePasswordRequest, AllMenuResponse, MenuResponse, ProfileResponse, ProfileUpdateRequest, AllNewsResponse, GeneralResponse, NewsResponse, AllEventsResponse, EventsResponse, OneEventResponse, AllDirectoriesResponse, DirectoriesResponse, AllEmergencyResponse, EmergencyDataResponse, EmergencyRequest, PasswordUpdateRequest, AllIncidenceResponse, IncidenceDataResponse, IncidenceRequest, AllIncidenceNoteResponse, IncidenceNoteDataResponse, IncidenceNoteRequest, CreateUpdateIncidenceNoteResponse, AllDocumentCategoryResponse, DocumentCategoryResponse, AllDocumentResponse, DocumentResponse, CatalogRequest, AllCatalogResponse, allCatalog, AllVotingResponse, VotingsResponse, AllChargePendingResponse, ChargePendingResponse, MobileTokenRequest, MobileTokenWithTypeRequest, AllCardResponse, CardDataResponse, AllPaysResponse, PaysDataResponse, CardSaveDataResponse, PayDataRequest, Pay3DDataRequest, PaypalDataRequest, PayPaypalRequest, CreatePayResponse, PayResponse, PayByStoreDataRequest, PayBySPEIDataRequest, CreatePay3DResponse, Pay3DResponse, AllChargesResponse, ChargesResponse, AllCommonAreaResponse, CommonAreaResponse, AllHousingResponse, HousingResponse, CreateHousingResponse, HousingRequest, HousingGuest, CheckAvailableDateRequest, HousingDetailResponse, HousingDetail, HousingDetailGuest, EditGuestsRequest, EditDateRequest, EditSubstitutesRequest, AllPetResponse, PetResponse, CreatePetRequest, UpdatePetRequest, CreateUpdatePetResponse, AllCommonAreaHourResponse, CommonAreaHourResponse, AllCommonAreaHourAvailableResponse, AllCommonAreaBlockResponse, CommonAreaBlockResponse, AllReservationResponse, ReservationByHouseResponse, DisabledCalendarDaysResponse, ReservationAvailabilityResource, ReservationResponse, CreateReservationResponse, ReservationRequest, ReservationBlockRequest, ReservationByStoreResponse, CreateReservationByStoreResponse, ReservationByStoreRequest, AllInvitationResponse, InvitationResponse, CreateInvitationResponse, InvitationRequest, AllFrequentInvitedResponse, FrequentInvitedResponse, FrequentInvitedRequest, AllCommissionResponse, CommissionResponse, ModulesDataResponse, AllComboboxResponse, ComboboxResponse, NoDataResponse, DataResponse, UrlResponse, IdResponse, StringResponse, AllDoorsResponse, DoorResponse, DroneRequest, DroneResponse, Drone, LockerPickupRequest, LockerBoxResponse, LockerBox, LockerResponse, Locker, AllMapResponse, MapResponse } from './models';

/**
* Created with angular4-swagger-client-generator.
*/
@Injectable()
export class ApiClientService {

  private domain = 'https://wsqa.frakcio.com/api/v1/mobile';

  constructor(private http: HttpClient, @Optional() @Inject('domain') domain: string ) {
    if (domain) {
      this.domain = domain;
    }
  }

  /**
  * Method login
  * @param body The Datos de login
  * @return The full HTTP response as Observable
  */
  public login(body: LoginRequest): Observable<HttpResponse<LoginResponse>> {
    let uri = `/auth/login`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<LoginResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method resetPassword
  * @param body The Correo electrónico del usuario
  * @return The full HTTP response as Observable
  */
  public resetPassword(body: ResetPasswordRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/auth/reset`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method changePassword
  * @param body The Contraseña y confirmación de contraseña
  * @return The full HTTP response as Observable
  */
  public changePassword(body: ChangePasswordRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/auth/change`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method getconfiguration
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public getconfiguration(Authorization: string): Observable<HttpResponse<any>> {
    let uri = `/configuration/getconfiguration`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method createViewNotification
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de la notificacion a crear
  * @return The full HTTP response as Observable
  */
  public createViewNotification(Authorization: string, idCondominium: number, body: ViewNotificationRequest): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/viewnotification`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method finance
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param year The Año
  * @param month The Mes
  * @param idEstimate The Estimación
  * @return The full HTTP response as Observable
  */
  public finance(Authorization: string, idCondominium: number, year: number, month: number, idEstimate: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/finance/${year}/${month}/${idEstimate}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method expenses
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param year The Año
  * @param month The Mes
  * @return The full HTTP response as Observable
  */
  public expenses(Authorization: string, idCondominium: number, year: number, month: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/expenses/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method detailexpense
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param year The Año
  * @param month The Mes
  * @param idConcept The idConcepto
  * @return The full HTTP response as Observable
  */
  public detailexpense(Authorization: string, idCondominium: number, year: number, month: number, idConcept: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/detailexpense/${year}/${month}/${idConcept}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method downloadXMLExpense
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idExpense The Id del gasto
  * @return The full HTTP response as Observable
  */
  public downloadXMLExpense(Authorization: string, idCondominium: number, idExpense: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/expenses/download/xml/${idExpense}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method downloadDocumentExpense
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idExpense The Id del gasto
  * @return The full HTTP response as Observable
  */
  public downloadDocumentExpense(Authorization: string, idCondominium: number, idExpense: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/expenses/download/document/${idExpense}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method downloadPDFExpense
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idExpense The Id del gasto
  * @return The full HTTP response as Observable
  */
  public downloadPDFExpense(Authorization: string, idCondominium: number, idExpense: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/expenses/download/pdf/${idExpense}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method menu
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public menu(Authorization: string): Observable<HttpResponse<AllMenuResponse>> {
    let uri = `/menu`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMenuResponse>('get', uri, headers, params, null);
  }

  /**
  * Method profile
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public profile(Authorization: string): Observable<HttpResponse<ProfileResponse>> {
    let uri = `/profile`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ProfileResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateProfile
  * @param Authorization The Condominios Movil
  * @param body The Datos fiscales
  * @return The full HTTP response as Observable
  */
  public updateProfile(Authorization: string, body: ProfileUpdateRequest): Observable<HttpResponse<ProfileResponse>> {
    let uri = `/profile`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ProfileResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updatePassword
  * @param Authorization The Condominios Movil
  * @param body The Datos fiscales
  * @return The full HTTP response as Observable
  */
  public updatePassword(Authorization: string, body: PasswordUpdateRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/password`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method news
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @return The full HTTP response as Observable
  */
  public news(Authorization: string, idCondominium: number, cant: number): Observable<HttpResponse<AllNewsResponse>> {
    let uri = `/condominium/${idCondominium}/news/${cant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllNewsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paginatednews
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @param skip The envia la cantidad de registros a partir de cual enviar
  * @return The full HTTP response as Observable
  */
  public paginatednews(Authorization: string, idCondominium: number, cant: number, skip: number): Observable<HttpResponse<AllNewsResponse>> {
    let uri = `/condominium/${idCondominium}/news/${cant}/${skip}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllNewsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method newsFavorites
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public newsFavorites(Authorization: string, idCondominium: number): Observable<HttpResponse<AllNewsResponse>> {
    let uri = `/condominium/${idCondominium}/news_favorites`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllNewsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method AgregaNews
  * @param Authorization The Condominios Movil
  * @param id The ID de la noticia
  * @return The full HTTP response as Observable
  */
  public AgregaNews(Authorization: string, id: number): Observable<HttpResponse<GeneralResponse>> {
    let uri = `/news_favorite/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GeneralResponse>('get', uri, headers, params, null);
  }

  /**
  * Method events
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @return The full HTTP response as Observable
  */
  public events(Authorization: string, idCondominium: number, cant: number): Observable<HttpResponse<AllEventsResponse>> {
    let uri = `/condominium/${idCondominium}/event/${cant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEventsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paginatedevents
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @param skip The envia la cantidad de registros a partir de cual enviar
  * @return The full HTTP response as Observable
  */
  public paginatedevents(Authorization: string, idCondominium: number, cant: number, skip: number): Observable<HttpResponse<AllEventsResponse>> {
    let uri = `/condominium/${idCondominium}/event/${cant}/${skip}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEventsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paginatedeventsexpired
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @param skip The envia la cantidad de registros a partir de cual enviar
  * @return The full HTTP response as Observable
  */
  public paginatedeventsexpired(Authorization: string, idCondominium: number, cant: number, skip: number): Observable<HttpResponse<AllEventsResponse>> {
    let uri = `/condominium/${idCondominium}/eventexpired/${cant}/${skip}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEventsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method eventFavorites
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public eventFavorites(Authorization: string, idCondominium: number): Observable<HttpResponse<AllNewsResponse>> {
    let uri = `/condominium/${idCondominium}/event_favorites`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllNewsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method AgregaEvent
  * @param Authorization The Condominios Movil
  * @param id The ID de la noticia
  * @return The full HTTP response as Observable
  */
  public AgregaEvent(Authorization: string, id: number): Observable<HttpResponse<GeneralResponse>> {
    let uri = `/event_favorite/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GeneralResponse>('get', uri, headers, params, null);
  }

  /**
  * Method event
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param id The id del evento
  * @return The full HTTP response as Observable
  */
  public event(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<OneEventResponse>> {
    let uri = `/condominium/${idCondominium}/eventbyid/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<OneEventResponse>('get', uri, headers, params, null);
  }

  /**
  * Method residentNews
  * @param Authorization The Condominios Movil
  * @param id The ID del residente
  * @return The full HTTP response as Observable
  */
  public residentNews(Authorization: string, id: number): Observable<HttpResponse<AllNewsResponse>> {
    let uri = `/resident/${id}/news`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllNewsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method residentEvents
  * @param Authorization The Condominios Movil
  * @param id The ID del residente
  * @return The full HTTP response as Observable
  */
  public residentEvents(Authorization: string, id: number): Observable<HttpResponse<AllEventsResponse>> {
    let uri = `/resident/${id}/events`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEventsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method directory
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public directory(Authorization: string, idCondominium: number): Observable<HttpResponse<AllDirectoriesResponse>> {
    let uri = `/condominium/${idCondominium}/directory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDirectoriesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method emergencies
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @return The full HTTP response as Observable
  */
  public emergencies(Authorization: string, idCondominium: number, cant: number): Observable<HttpResponse<AllEmergencyResponse>> {
    let uri = `/condominium/${idCondominium}/emergency/${cant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEmergencyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method emergenciespaged
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @param skip The registros que se omiten
  * @return The full HTTP response as Observable
  */
  public emergenciespaged(Authorization: string, idCondominium: number, cant: number, skip: number): Observable<HttpResponse<AllEmergencyResponse>> {
    let uri = `/condominium/${idCondominium}/emergency/${cant}/${skip}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEmergencyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method savEmergency
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public savEmergency(Authorization: string, idCondominium: number, body: EmergencyRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/emergency`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method incidences
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @return The full HTTP response as Observable
  */
  public incidences(Authorization: string, idCondominium: number, cant: number): Observable<HttpResponse<AllIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/incidence/${cant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllIncidenceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method incidencespaged
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @param skip The envia la cantidad de registros a enviar
  * @return The full HTTP response as Observable
  */
  public incidencespaged(Authorization: string, idCondominium: number, cant: number, skip: number): Observable<HttpResponse<AllIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/incidence/${cant}/${skip}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllIncidenceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method savIncidence
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Incidencias
  * @return The full HTTP response as Observable
  */
  public savIncidence(Authorization: string, idCondominium: number, body: IncidenceRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/incidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method incidencesnote
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idIncidence The id de incidencia
  * @return The full HTTP response as Observable
  */
  public incidencesnote(Authorization: string, idCondominium: number, idIncidence: number): Observable<HttpResponse<AllIncidenceNoteResponse>> {
    let uri = `/condominium/${idCondominium}/incidencenote/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllIncidenceNoteResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createincidencenote
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idIncidence The id de incidencia
  * @param body The Datos de la Nota de Incidencia
  * @return The full HTTP response as Observable
  */
  public createincidencenote(Authorization: string, idCondominium: number, idIncidence: number, body: IncidenceNoteRequest): Observable<HttpResponse<CreateUpdateIncidenceNoteResponse>> {
    let uri = `/condominium/${idCondominium}/incidencenote/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateIncidenceNoteResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method catalog
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public catalog(Authorization: string): Observable<HttpResponse<CatalogRequest>> {
    let uri = `/catalog`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CatalogRequest>('get', uri, headers, params, null);
  }

  /**
  * Method votings
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @return The full HTTP response as Observable
  */
  public votings(Authorization: string, idCondominium: number, cant: number): Observable<HttpResponse<AllVotingResponse>> {
    let uri = `/condominium/${idCondominium}/voting/${cant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllVotingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method votingspaged
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param cant The envia la cantidad de registros a enviar
  * @param skip The registros que se ignoran
  * @return The full HTTP response as Observable
  */
  public votingspaged(Authorization: string, idCondominium: number, cant: number, skip: number): Observable<HttpResponse<AllVotingResponse>> {
    let uri = `/condominium/${idCondominium}/voting/${cant}/${skip}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllVotingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method emiteVoto
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param id The ID del proyecto
  * @param change The voto positivo o negativo 1 o 0
  * @return The full HTTP response as Observable
  */
  public emiteVoto(Authorization: string, idCondominium: number, id: number, change: number): Observable<HttpResponse<GeneralResponse>> {
    let uri = `/condominium/${idCondominium}/voting_change/${id}/${change}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GeneralResponse>('get', uri, headers, params, null);
  }

  /**
  * Method chargePending
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id la casa
  * @return The full HTTP response as Observable
  */
  public chargePending(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllChargePendingResponse>> {
    let uri = `/condominium/${idCondominium}/charge_pending/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllChargePendingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method deleteCard
  * @param Authorization The Condominios Movil
  * @param id The id de tarjeta a eliminar
  * @return The full HTTP response as Observable
  */
  public deleteCard(Authorization: string, id: number): Observable<HttpResponse<GeneralResponse>> {
    let uri = `/deleteCard/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GeneralResponse>('get', uri, headers, params, null);
  }

  /**
  * Method getCard
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public getCard(Authorization: string): Observable<HttpResponse<AllCardResponse>> {
    let uri = `/getCard`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCardResponse>('get', uri, headers, params, null);
  }

  /**
  * Method saveCard
  * @param Authorization The Condominios Movil
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public saveCard(Authorization: string, body: CardSaveDataResponse): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/saveCard`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method pay
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public pay(Authorization: string, idCondominium: number, body: PayDataRequest): Observable<HttpResponse<CreatePayResponse>> {
    let uri = `/condominium/${idCondominium}/pay`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreatePayResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method pay3dsecurity
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public pay3dsecurity(Authorization: string, idCondominium: number, body: Pay3DDataRequest): Observable<HttpResponse<CreatePay3DResponse>> {
    let uri = `/condominium/${idCondominium}/pay3dsecurity`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreatePay3DResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method paybypaypal
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos del pago
  * @return The full HTTP response as Observable
  */
  public paybypaypal(Authorization: string, idCondominium: number, body: PayPaypalRequest): Observable<HttpResponse<StringResponse>> {
    let uri = `/condominium/${idCondominium}/paybypaypal`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<StringResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method getPays
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public getPays(Authorization: string): Observable<HttpResponse<AllPaysResponse>> {
    let uri = `/getPays`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPaysResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pays
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param page The pagina
  * @return The full HTTP response as Observable
  */
  public pays(Authorization: string, idCondominium: number, idHouse: number, page: number): Observable<HttpResponse<AllPaysResponse>> {
    let uri = `/condominium/${idCondominium}/pay/${page}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPaysResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paybystore
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public paybystore(Authorization: string, idCondominium: number, body: PayByStoreDataRequest): Observable<HttpResponse<CreatePayResponse>> {
    let uri = `/condominium/${idCondominium}/paybystore`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreatePayResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method paypaypal
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public paypaypal(Authorization: string, idCondominium: number, body: PaypalDataRequest): Observable<HttpResponse<CreatePayResponse>> {
    let uri = `/condominium/${idCondominium}/paypaypal`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreatePayResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method paybyspei
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos de Emergencia
  * @return The full HTTP response as Observable
  */
  public paybyspei(Authorization: string, idCondominium: number, body: PayBySPEIDataRequest): Observable<HttpResponse<CreatePayResponse>> {
    let uri = `/condominium/${idCondominium}/paybyspei`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreatePayResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method pdfAccountStatement
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public pdfAccountStatement(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/pdfaccountstatement/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfAccountStatementByYear
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param year The año
  * @return The full HTTP response as Observable
  */
  public pdfAccountStatementByYear(Authorization: string, idCondominium: number, idHouse: number, year: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/pdfaccountstatement/${idHouse}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method chargesbypayment
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idPayment The Id del pago
  * @return The full HTTP response as Observable
  */
  public chargesbypayment(Authorization: string, idCondominium: number, idPayment: number): Observable<HttpResponse<AllChargesResponse>> {
    let uri = `/condominium/${idCondominium}/chargesbypayment/${idPayment}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllChargesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method usoCfdi
  * @param Authorization The Condominios Movil
  * @return The full HTTP response as Observable
  */
  public usoCfdi(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/uso_cfdi`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updatemobiletoken
  * @param Authorization The Condominios Movil
  * @param body The Datos de token mobile
  * @return The full HTTP response as Observable
  */
  public updatemobiletoken(Authorization: string, body: MobileTokenRequest): Observable<HttpResponse<LoginResponse>> {
    let uri = `/mobile_token`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<LoginResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method savemobiletoken
  * @param Authorization The Condominios Movil
  * @param body The Datos de token mobile
  * @return The full HTTP response as Observable
  */
  public savemobiletoken(Authorization: string, body: MobileTokenWithTypeRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/mobile_token`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method commonarea
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public commonarea(Authorization: string, idCondominium: number): Observable<HttpResponse<AllCommonAreaResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housing
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param cant The Cantidad de registros
  * @return The full HTTP response as Observable
  */
  public housing(Authorization: string, idCondominium: number, idHouse: number, cant: number): Observable<HttpResponse<AllHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housing/${idHouse}/${cant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHousingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createHousing
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param body The Datos de la reservación
  * @return The full HTTP response as Observable
  */
  public createHousing(Authorization: string, idCondominium: number, idHouse: number, body: HousingRequest): Observable<HttpResponse<CreateHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housing/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateHousingResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method checkavailabledate
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param body The Fechas a validar
  * @return The full HTTP response as Observable
  */
  public checkavailabledate(Authorization: string, idCondominium: number, idHouse: number, body: CheckAvailableDateRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/checkavailabledate/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method housingUrlS3
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param id The ID del hospedaje
  * @return The full HTTP response as Observable
  */
  public housingUrlS3(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/housings3/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housingDetail
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param id The ID del hospedaje
  * @return The full HTTP response as Observable
  */
  public housingDetail(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<HousingDetailResponse>> {
    let uri = `/condominium/${idCondominium}/housingdetail/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<HousingDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method deleteHousing
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param id The ID del hospedaje a eliminar
  * @return The full HTTP response as Observable
  */
  public deleteHousing(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/deletehousing/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method editGuests
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public editGuests(Authorization: string, idCondominium: number, body: EditGuestsRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/editguests`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editDate
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos para la edición
  * @return The full HTTP response as Observable
  */
  public editDate(Authorization: string, idCondominium: number, body: EditDateRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/editdate`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editSubstitutes
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public editSubstitutes(Authorization: string, idCondominium: number, body: EditGuestsRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/editsubstitutes`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method pet
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public pet(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllPetResponse>> {
    let uri = `/condominium/${idCondominium}/pet/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPetResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createPet
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param body The Datos para la edición
  * @return The full HTTP response as Observable
  */
  public createPet(Authorization: string, idCondominium: number, idHouse: number, body: CreatePetRequest): Observable<HttpResponse<CreateUpdatePetResponse>> {
    let uri = `/condominium/${idCondominium}/pet/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdatePetResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updatePet
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param body The Datos para la edición
  * @return The full HTTP response as Observable
  */
  public updatePet(Authorization: string, idCondominium: number, idHouse: number, body: UpdatePetRequest): Observable<HttpResponse<CreateUpdatePetResponse>> {
    let uri = `/condominium/${idCondominium}/pet/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdatePetResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deletePet
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public deletePet(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/pet/delete/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method commonareahour
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idCommonArea The Id de la área común
  * @return The full HTTP response as Observable
  */
  public commonareahour(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<AllCommonAreaHourResponse>> {
    let uri = `/condominium/${idCondominium}/commonareahour/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaHourResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonareahouravailable
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idCommonArea The Id de la área común
  * @param date The fecha de la reservación
  * @param idCommonAreaHour The id del area común hora
  * @return The full HTTP response as Observable
  */
  public commonareahouravailable(Authorization: string, idCondominium: number, idCommonArea: number, date: string, idCommonAreaHour: number): Observable<HttpResponse<AllCommonAreaHourAvailableResponse>> {
    let uri = `/condominium/${idCondominium}/commonareahouravailable/${idCommonArea}/${date}/${idCommonAreaHour}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaHourAvailableResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonareablock
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idCommonArea The Id de la área común
  * @param date The fecha de la reservación
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public commonareablock(Authorization: string, idCondominium: number, idCommonArea: number, date: string, idHouse: number): Observable<HttpResponse<AllCommonAreaBlockResponse>> {
    let uri = `/condominium/${idCondominium}/commonareablock/${idCommonArea}/${date}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaBlockResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reservation
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idCommonArea The Id del área común
  * @return The full HTTP response as Observable
  */
  public reservation(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<AllReservationResponse>> {
    let uri = `/condominium/${idCondominium}/reservation/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllReservationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method deletereservation
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idReserve The Id de la reservation
  * @return The full HTTP response as Observable
  */
  public deletereservation(Authorization: string, idCondominium: number, idReserve: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/reservationdelete/${idReserve}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method reservationbyhouse
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public reservationbyhouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<ReservationByHouseResponse>> {
    let uri = `/condominium/${idCondominium}/reservationbyhouse/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReservationByHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createreservation
  * @param Authorization The Condominios Movil
  * @param body The Datos de la reservación
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public createreservation(Authorization: string, body: ReservationRequest, idCondominium: number): Observable<HttpResponse<CreateReservationResponse>> {
    let uri = `/condominium/${idCondominium}/reservation`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateReservationResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method createreservationblock
  * @param Authorization The Condominios Movil
  * @param body The Datos de la reservación
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public createreservationblock(Authorization: string, body: ReservationBlockRequest, idCondominium: number): Observable<HttpResponse<CreateReservationResponse>> {
    let uri = `/condominium/${idCondominium}/reservationblock`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateReservationResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method createreservationbystore
  * @param Authorization The Condominios Movil
  * @param body The Datos de la reservación
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public createreservationbystore(Authorization: string, body: ReservationByStoreRequest, idCondominium: number): Observable<HttpResponse<CreateReservationByStoreResponse>> {
    let uri = `/condominium/${idCondominium}/reservationbystore`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateReservationByStoreResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method disabledcalendardays
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area comun
  * @return The full HTTP response as Observable
  */
  public disabledcalendardays(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<DisabledCalendarDaysResponse>> {
    let uri = `/condominium/${idCondominium}/disabledcalendardays/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DisabledCalendarDaysResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reservationavailability
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area comun
  * @param idHouse The Id de la casa
  * @param date The fecha que se quiere reservar
  * @return The full HTTP response as Observable
  */
  public reservationavailability(Authorization: string, idCondominium: number, idCommonArea: number, idHouse: number, date: string): Observable<HttpResponse<ReservationAvailabilityResource>> {
    let uri = `/condominium/${idCondominium}/reservationavailability/${idCommonArea}/${idHouse}/${date}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReservationAvailabilityResource>('get', uri, headers, params, null);
  }

  /**
  * Method invitation
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public invitation(Authorization: string, idCondominium: number): Observable<HttpResponse<AllInvitationResponse>> {
    let uri = `/condominium/${idCondominium}/invitation`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllInvitationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createinvitation
  * @param Authorization The Condominios Movil
  * @param body The Datos de la invitación
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public createinvitation(Authorization: string, body: InvitationRequest, idCondominium: number): Observable<HttpResponse<CreateInvitationResponse>> {
    let uri = `/condominium/${idCondominium}/invitation`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateInvitationResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteinvitation
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param id The Id de invitación a eliminar
  * @return The full HTTP response as Observable
  */
  public deleteinvitation(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/invitation/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method frequentInvited
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public frequentInvited(Authorization: string, idCondominium: number): Observable<HttpResponse<AllFrequentInvitedResponse>> {
    let uri = `/condominium/${idCondominium}/frequentinvited`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllFrequentInvitedResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createInvitedFrequent
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos del invitado frecuente
  * @return The full HTTP response as Observable
  */
  public createInvitedFrequent(Authorization: string, idCondominium: number, body: FrequentInvitedRequest): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/frequentinvited`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editInvitedFrequent
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos del invitado frecuente
  * @return The full HTTP response as Observable
  */
  public editInvitedFrequent(Authorization: string, idCondominium: number, body: FrequentInvitedRequest): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/frequentinvited`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteFrequentInvited
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param id The ID del invitado frecuente
  * @return The full HTTP response as Observable
  */
  public deleteFrequentInvited(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/frequentinvited/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method documentCategory
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public documentCategory(Authorization: string, idCondominium: number): Observable<HttpResponse<AllDocumentCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/documentcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDocumentCategoryResponse>('get', uri, headers, params, null);
  }

  /**
  * Method documentbycategory
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idCategory The Id de la categoría
  * @return The full HTTP response as Observable
  */
  public documentbycategory(Authorization: string, idCondominium: number, idCategory: number): Observable<HttpResponse<AllDocumentResponse>> {
    let uri = `/condominium/${idCondominium}/documentbycategory/${idCategory}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDocumentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method documentUrlS3
  * @param Authorization The Condominios Movil
  * @param idCondominium The ID del condominio
  * @param idDocument The ID del condominio
  * @return The full HTTP response as Observable
  */
  public documentUrlS3(Authorization: string, idCondominium: number, idDocument: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/documenturls3/${idDocument}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housecombobox
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public housecombobox(Authorization: string, idCondominium: number): Observable<HttpResponse<AllComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/housecombobox`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method estimatecombobox
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param year The año
  * @return The full HTTP response as Observable
  */
  public estimatecombobox(Authorization: string, idCondominium: number, year: number): Observable<HttpResponse<AllComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/estimatecombobox/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method yearsofestimatecombobox
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public yearsofestimatecombobox(Authorization: string, idCondominium: number): Observable<HttpResponse<AllComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/yearsofestimatecombobox`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method incidenceareas
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public incidenceareas(Authorization: string, idCondominium: number): Observable<HttpResponse<AllComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/incidenceareas`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method incidencetypes
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idArea The Id del área
  * @return The full HTTP response as Observable
  */
  public incidencetypes(Authorization: string, idCondominium: number, idArea: number): Observable<HttpResponse<AllComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/incidencetypes/${idArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reasonvisit
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public reasonvisit(Authorization: string, idCondominium: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/common/reasonvisit`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method species
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public species(Authorization: string, idCondominium: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/common/species`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method typesvehicle
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public typesvehicle(Authorization: string, idCondominium: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/common/typesvehicle`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method brandsvehicle
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public brandsvehicle(Authorization: string, idCondominium: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/common/brandsvehicle`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method colors
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public colors(Authorization: string, idCondominium: number): Observable<HttpResponse<any>> {
    let uri = `/condominium/${idCondominium}/common/colors`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<any>('get', uri, headers, params, null);
  }

  /**
  * Method commission
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param amount The cantidad
  * @param typePayment The typo de pago tienda o tarjeta
  * @param typeCard The Tipo de tarjeta visa o american
  * @return The full HTTP response as Observable
  */
  public commission(Authorization: string, idCondominium: number, amount: number, typePayment: number, typeCard: number): Observable<HttpResponse<AllCommissionResponse>> {
    let uri = `/condominium/${idCondominium}/commission/${amount}/${typePayment}/${typeCard}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommissionResponse>('get', uri, headers, params, null);
  }

  /**
  * Method modules
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public modules(Authorization: string, idCondominium: number): Observable<HttpResponse<ModulesDataResponse>> {
    let uri = `/condominium/${idCondominium}/modules`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ModulesDataResponse>('get', uri, headers, params, null);
  }

  /**
  * Method condominium
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public condominium(Authorization: string, idCondominium: number): Observable<HttpResponse<CondominiumResponse>> {
    let uri = `/condominium/${idCondominium}/condominium`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CondominiumResponse>('get', uri, headers, params, null);
  }

  /**
  * Method qr
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public qr(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/qr/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method qrstaticresident
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public qrstaticresident(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/qrstaticresident`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dooraction
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idAccessPanel The Id del panel
  * @param number The numero de puerta (no confundir con el id)
  * @param action The 1 abre la puerta y 0 la cierra
  * @return The full HTTP response as Observable
  */
  public dooraction(Authorization: string, idCondominium: number, idAccessPanel: number, number: number, action: number): Observable<HttpResponse<GeneralResponse>> {
    let uri = `/condominium/${idCondominium}/panel/${idAccessPanel}/door/${number}/action/${action}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GeneralResponse>('get', uri, headers, params, null);
  }

  /**
  * Method doors
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public doors(Authorization: string, idCondominium: number): Observable<HttpResponse<AllDoorsResponse>> {
    let uri = `/condominium/${idCondominium}/doors`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDoorsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method launchDrone
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos para lanzar el dron
  * @return The full HTTP response as Observable
  */
  public launchDrone(Authorization: string, idCondominium: number, body: DroneRequest): Observable<HttpResponse<DroneResponse>> {
    let uri = `/condominium/${idCondominium}/drone/launch`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DroneResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method lockerpickup
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param body The Datos para recoger los paquetes del locker
  * @return The full HTTP response as Observable
  */
  public lockerpickup(Authorization: string, idCondominium: number, body: LockerPickupRequest): Observable<HttpResponse<GeneralResponse>> {
    let uri = `/condominium/${idCondominium}/locker/pickup`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GeneralResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method lockerbox
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public lockerbox(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<LockerBoxResponse>> {
    let uri = `/condominium/${idCondominium}/locker/box/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<LockerBoxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method locker
  * @param Authorization The Condominios Movil
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public locker(Authorization: string, idCondominium: number): Observable<HttpResponse<LockerResponse>> {
    let uri = `/condominium/${idCondominium}/locker`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<LockerResponse>('get', uri, headers, params, null);
  }

  private sendRequest<T>(method: string, uri: string, headers: HttpHeaders, params: HttpParams, body: any): Observable<HttpResponse<T>> {
    if (method === 'get') {
      return this.http.get<T>(this.domain + uri, { headers: headers.set('Accept', 'application/json'), params: params, observe: 'response' });
    } else if (method === 'put') {
      return this.http.put<T>(this.domain + uri, body, { headers: headers.set('Content-Type', 'application/json'), params: params, observe: 'response' });
    } else if (method === 'post') {
      return this.http.post<T>(this.domain + uri, body, { headers: headers.set('Content-Type', 'application/json'), params: params, observe: 'response' });
    } else if (method === 'delete') {
      return this.http.delete<T>(this.domain + uri, { headers: headers, params: params, observe: 'response' });
    } else {
      console.error('Unsupported request: ' + method);
      return Observable.throw('Unsupported request: ' + method);
    }
  }
}
